module.exports = __webpack_public_path__ + "img/03.f11f1f45.png";